import { render, staticRenderFns } from "./ImportData.vue?vue&type=template&id=234927cd&scoped=true"
import script from "./ImportData.vue?vue&type=script&lang=js"
export * from "./ImportData.vue?vue&type=script&lang=js"
import style0 from "./ImportData.vue?vue&type=style&index=0&id=234927cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234927cd",
  null
  
)

export default component.exports